module.exports = __webpack_public_path__ + "static/media/upload-game-illustration-SPANISH.41057af7.png";